import React from "react";
import PropTypes from "prop-types";

// components
import { AttributionDisplayTextStyled, TnpLinkStyled } from "./styles";

const AttributionDisplayText = ({
    assetTitle,
    creatorName,
    url,
    anchorTitle,
    darkMode = false,
    license
}) => {
    return (
        <AttributionDisplayTextStyled darkMode={darkMode}>
            {assetTitle} by {creatorName} from{" "}
            <TnpLinkStyled
                href={url}
                target="_blank"
                title={anchorTitle}
                darkMode={darkMode}
                size="sm"
            >
                Noun Project
            </TnpLinkStyled>{" "}
            ({license})
        </AttributionDisplayTextStyled>
    );
};

export default AttributionDisplayText;

// prop-types
AttributionDisplayText.propTypes = {
    assetTitle: PropTypes.string,
    creatorName: PropTypes.string,
    url: PropTypes.string,
    anchorTitle: PropTypes.string,
    darkMode: PropTypes.bool
};
